import {getUserInfo,signOut} from './interface-user'
import {getUserConfig,saveUserConfig} from './interface-nav-config'

let mergeInterface = Object.assign({}, {getUserInfo,signOut}, {getUserConfig,saveUserConfig})

export default mergeInterface



// WEBPACK FOOTER //
// ./src/api/interface.js